import { DocumentMessage, NoteCreateFormValues } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { MIDDLE_OFFICE_BASE_PATH } from '../../constants/middleOfficeBasePath';

export const postCreateApplicationNote = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
  data: NoteCreateFormValues,
): Promise<NonPaginatedResponse<DocumentMessage> | undefined> =>
  constructPost(
    `${MIDDLE_OFFICE_BASE_PATH}/${uuid}/messages`,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
